import { render, staticRenderFns } from "./VoyageSectionNav.vue?vue&type=template&id=c7832cee&scoped=true"
import script from "./VoyageSectionNav.vue?vue&type=script&lang=js"
export * from "./VoyageSectionNav.vue?vue&type=script&lang=js"
import style0 from "./VoyageSectionNav.vue?vue&type=style&index=0&id=c7832cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.44.2__css-load_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7832cee",
  null
  
)

export default component.exports